/**
 *  This File will Contains all Constants Used in the whole
 *  Client Code In order to make it more Cleaner
 */

// This is the config used in order to send
// our token with Axios requests
export const config = (jwt) => {
  return {
    headers: {
      Authorization: "Bearer " + jwt,
    },
  };
};

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

/**
 * EndPoints labels
 */

export const CREATE_POST_URL = `${API_BASE_URL}/createpost`;

export const ALL_POSTS_URL = `${API_BASE_URL}/allpost`;

export const LOGIN_URL = `${API_BASE_URL}/signin`;

export const NEW_PWD_URL = `${API_BASE_URL}/new-pwd`;

export const MY_POST_URL = `${API_BASE_URL}/mypost`;
export const MY_BOOKMARKS_URL = `${API_BASE_URL}/bookmarks`;

export const RESET_PWD_URL = `${API_BASE_URL}/reset-pwd`;

export const SIGNUP_URL = `${API_BASE_URL}/signup`;

export const SUB_POST_URL = `${API_BASE_URL}/subspost`;
